export default function PaginationComponent({ currentPage, totalPages, onPageChange }) {
  if (!totalPages) return null;

  const handleClick = (e, page) => {
    e.preventDefault();
    onPageChange(page);
  };

  return (
    <ul className="pagination">
      {[...Array(totalPages)].map((_, i) => {
        const page = i + 1;
        return (
          <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
            <a
              href={`?page=${page}`}
              className="page-link"
              onClick={(e) => handleClick(e, page)}
            >
              {page}
            </a>
          </li>
        );
      })}
    </ul>
  );
}
